/**
* @file 战队-成员管理
* @author 余凯
*/

import React from 'react'
import { Table, Button, Form, Input, Checkbox, message } from 'antd';
import './index.less'

import { connect } from 'react-redux'

import Actions from '@/apis/team'
import Dict from '@/utils/dict'

const columns = [
  {
    title: '职务',
    dataIndex: 'team_job',
    sorter: (a, b) => null,
  },
  {
    title: '队员ID',
    dataIndex: 'user_id',
  },
  {
    title: '昵称',
    dataIndex: 'nickname',
  },
  {
    title: '威望值',
    dataIndex: 'prestige',
    sorter: (a, b) => null,
  },
  {
    title: '手机',
    dataIndex: 'telephone',
  },
  {
    title: '加入时间',
    dataIndex: 'join_time',
    render: (action, record) => record.join_time.split(' ')[0],
    sorter: (a, b) => null,
  },
  {
    title: '登录时间',
    dataIndex: 'login_time',
    sorter: (a, b) => null,
    render: (action, record) => (new Date(record.login_time) - new Date(record.logout_time) > 0 ? '在线' : record.logout_time)
  },
];

@Form.create()
@connect(
  state => state.teamReducer,

)
class MemberManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      data: [],
      totalCount: 0,
      current: 1,
      paramsOnline: 0,
      paramsOrder: 1,
      pageSize: 10
    }
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
    });
  };

  start = () => {
    this.setState({ loading: true });
    // ajax request after empty completing
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        loading: false,
      });
    }, 1000);
  };

  componentDidMount() {
    this.getData()
  }

  getData = async (pageCurrent = this.state.current) => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      is_online: this.state.paramsOnline,
      order_type: this.state.paramsOrder,
      page_index: pageCurrent,
      // page_size: 9999
      page_size: this.state.pageSize,
      user: this.state.filterName
    }
    // if (this.state.filterName) {
    //   params.user = this.state.filterName
    // }
    const res = await Actions.getMemberList(params)
    if (res.code == 200) {
      this.setState({
        data: res.data.list,
        totalCount: res.data.totalNumber,
        current: pageCurrent
      })
    }
  }

  handleChangePage = (page, pageSize) => {

  }

  handleCheckOnline = e => {
    this.setState({
      paramsOnline: e.target.checked ? '1' : '0'
    }, () => {
      this.getData()
    })
  }

  handleChangeTable = (pagination, filters, sorter, extra) => {
    const dictObj = {
      team_job: 1,
      join_time: 2,
      prestige: 3,
      login_time: 4
    }
    this.setState({
      paramsOrder: sorter.order == 'descend' ? dictObj[sorter.field] : this.state.order_type,
    }, () => {
      this.getData(pagination.current)
    })
  }

  handleChangeJob = async (param) => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      user_ids: this.state.selectedRowKeys,
      ...param
    }
    const res = await Actions.putChangeJob(params)
    if (res.code == 200) {
      message.success('操作成功')
      this.getData()
      this.setState({
        selectedRowKeys: [],
      })
    }
  }

  handleRemoveMember = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      user_ids: this.state.selectedRowKeys
    }
    const res = await Actions.putRemoveMenber(params)
    if (res.code == 200) {
      message.success('操作成功')
      this.getData()
      this.setState({
        selectedRowKeys: [],

      })
    }
  }

  renderCell = (record) => {
    const job = this.props.userInfo.team_job
    const itemJob = record.team_jobs_value
    const { CAPTAIN, VICE_CAPTAIN } = Dict.ROLES
    if (job == CAPTAIN && itemJob == CAPTAIN) {
      return { disabled: true, hidden: true }
    }
    if (job == VICE_CAPTAIN && (itemJob == CAPTAIN || itemJob == VICE_CAPTAIN)) {
      return { disabled: true, hidden: true }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          filterName: values.name
        }, () => {
          this.getData(1)
        })
      }
    });
  };

  handleRow = (item) => {
    return {
      onClick: event => {
        const job = this.props.userInfo.team_job
        const itemJob = item.team_jobs_value
        const { CAPTAIN, VICE_CAPTAIN } = Dict.ROLES
        if (job == CAPTAIN && itemJob == CAPTAIN) {
          return false
        }
        if (job == VICE_CAPTAIN && (itemJob == CAPTAIN || itemJob == VICE_CAPTAIN)) {
          return false
        }
        const { selectedRowKeys } = this.state
        const i = selectedRowKeys.indexOf(item.user_id)
        if (i > -1) {
          selectedRowKeys.splice(i, 1)
          this.setState({
            selectedRowKeys
          })
        } else {
          selectedRowKeys.push(item.user_id)
          this.setState({
            selectedRowKeys
          })
        }
      }
    };
  }

  render() {
    const { data, pageSize, totalCount, current, selectedRowKeys } = this.state;
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: this.renderCell,
      hideDefaultSelections: true,
      columnTitle: ' '
    };
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div className="enqueue_approval" id="enqueue_approval">
        <h3>成员管理</h3>
        {/* <div className="tip">请及时审批入队申请，系统将保留申请数据一定的时间，超时将会被系统自动清理。</div> */}
        <div>
          <div style={{ marginBottom: 16 }} />
          <Form style={{ textAlign: 'right' }} layout="inline" onSubmit={this.handleSubmit}>
            <Form.Item >
              {getFieldDecorator('name')(
                <Input placeholder="请输入队员ID或名称" />,
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" >
                搜索
              </Button>
            </Form.Item>
          </Form>
          <Table
            rowKey={record => record.user_id}
            onRow={this.handleRow}
            title={() => (
              <>
                {this.props.userInfo.team_job === 'CAPTAIN' ? (
                  <>
                    <Button disabled={!hasSelected} type="primary" onClick={() => this.handleChangeJob({ op_type: 'set', job_type: '8' })} >
                      提升副队长
                    </Button>
                    <Button disabled={!hasSelected} type="primary" onClick={() => this.handleChangeJob({ op_type: 'cancel', job_type: '8' })} >
                      取消副队长
                    </Button>
                  </>
                ) : ''}
                {this.props.userInfo.team_job === 'CAPTAIN' || this.props.userInfo.team_job === 'VICE_CAPTAIN' ? (
                  <>
                    <Button disabled={!hasSelected} type="primary" onClick={() => this.handleChangeJob({ op_type: 'set', job_type: '1' })} >
                      设置精英
                    </Button>
                    <Button disabled={!hasSelected} type="primary" onClick={() => this.handleChangeJob({ op_type: 'cancel', job_type: '1' })} >
                      取消精英
                    </Button>
                    <Button disabled={!hasSelected} type="primary" onClick={this.handleRemoveMember} >
                      请离战队
                    </Button>
                  </>
                ) : ''}

                <Checkbox style={{ float: 'right' }} onChange={this.handleCheckOnline}>只显示在线</Checkbox>
              </>
            )}
            // bordered
            size="small"
            rowSelection={rowSelection}
            columns={columns}
            onChange={this.handleChangeTable}
            sortDirections={['descend']}
            pagination={{ pageSize, current, total: totalCount, onChange: this.handleChangePage }}
            dataSource={data} />
        </div>
      </div>
    );
  }
}

export default MemberManage;
